const ScrollMagic = require('scrollmagic');
const { CountUp } = require('countup.js');

var controller = new ScrollMagic.Controller();

class HomePage {
    constructor() {
        $('.inline').modaal();
    
        if($("#stats-list").length) {
            var stateScene = new ScrollMagic.Scene({
                triggerElement: "#stats-list",
                duration: 100,
                offset: -200
            })
            .addTo(controller)
            // .addIndicators() // add indicators (requires plugin)
            .on("enter leave", function (e) {
                if (!$("#stats-list").hasClass("visible")) {
                    $("#stats-list").addClass("visible");
                    $(".stats-item > span").each((_, x) => {
                        var val = parseInt($(x).text());
                        var c = new CountUp(x, val);
                        c.start();
                    });
                }
            });
        }
    }
}

export default HomePage;